import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { ReverifyComponent } from '../reverify/reverify.component';
import { ForgotPasswordComponent } from '../forgot-password/reverify-forgot-password.component';
import {NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../app.component.scss', './login.component.scss', '../auth.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  loginUserBtnStatus: boolean;

  // images = [
  //   'assets/images/carousel/image-1.jpg',
  //   'assets/images/carousel/image-2.jpg',
  //   'assets/images/carousel/image-3.jpg',
  //   'assets/images/carousel/image-4.jpg',
  //   'assets/images/carousel/image-5.png',
  //   'assets/images/carousel/image-6.jpg',
  // ];

  slides = [
    { 
      image: 'assets/images/carousel/image-1.jpg', 
      title: 'Welcome to Akashic Soft', 
      description: 'Discover new ideas every day!' 
    },
    { 
      image: 'assets/images/carousel/image-2.jpg', 
      title: 'Your Interests Matter', 
      description: 'Save what you love, discover what you like.' 
    },
    { 
      image: 'assets/images/carousel/image-3.jpg', 
      title: 'Explore & Create', 
      description: 'Find inspirations and share your creativity!' 
    }
  ];
  // showNavigationArrows = false;
  // showNavigationIndicators = false;

  currentIndex = 0;
  intervalId: any;

  // images = [1055, 194, 368].map((n) => `https://picsum.photos/id/${n}/900/500`);

  constructor(public toastService: ToastService, private _auth: AuthService, private _router: Router, private activatedRoute: ActivatedRoute, config: NgbCarouselConfig) {

    // customize default values of carousels used by this component tree
    config.showNavigationArrows = true;
    config.showNavigationIndicators = true;
  }

  @ViewChild(ReverifyComponent, {static: true})
  private reverifyComponent: ReverifyComponent;

  @ViewChild(ForgotPasswordComponent, {static: true})
  private reverifyForgotPassComponent: ForgotPasswordComponent;

  loginUserData =  {} as any;
  redirectUrl = '';
  sourceUrl = '';
  private _opened = false;
  private _openedForgotPassword = false;

  public emailResetData: any = '';

  private _toggleSidebar() {
    this._opened = !this._opened;
    this._openedForgotPassword = false;
    this.resetVerifyForm();
  }

  private _toggleForgotPasswordSidebar() {
    this._openedForgotPassword = !this._openedForgotPassword;
    this._opened = false;
    this.resetForgotPassForm();
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(
      params => {
        this.redirectUrl = params.redirectUrl;
        this.sourceUrl = params.sourceUrl;
      }
    );

    // check if user is logged in
    const isLogin = localStorage.getItem('isLogin');
    if (isLogin && isLogin === 'y') {
      this._router.navigate(['/auth/status'], { queryParams: {redirectUrl: this.redirectUrl, sourceUrl: this.sourceUrl} });
    }
 
    this.startAutoSlide();
  }

  startAutoSlide() {
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 8000); // Change every 4 seconds
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  

  resetVerifyForm() {
    this.reverifyComponent.resetForm();
  }

  resetForgotPassForm() {
    this.reverifyForgotPassComponent.resetForgotPassEmail();
  }

  loginUser() {
    this.loginUserBtnStatus = true;
    this.loginUserData.device = {
      platform: navigator.platform,
      userAgent: navigator.userAgent
    }
    this._auth.loginUser(this.loginUserData)
      .subscribe(
        res => {
          localStorage.clear();
          localStorage.setItem('code', res.access_code.access_code);
          localStorage.setItem('isLogin', 'y');
          console.log(res.access_code);
          // const userAuthRes = this._auth.getCurrentUserAuthenticate();
          window.location.href = this.redirectUrl + '?code=' + res.access_code.access_code + '&sourceUrl=' + this.sourceUrl;
        }, error => {
          this.loginUserBtnStatus = false;
          console.log(error.status)
          if (error.status === 0) {
            this.showDanger('We are experiencing some issues, Please try after sometime!');
          } else if (error.status === 400) {
            console.log(error.error);
            const errorData = error.error;
            for (const key in errorData) {
              if (errorData.hasOwnProperty(key)) {
                const val = errorData[key];
                this.showDanger(val);
              }
            }
          } else if (error.status === 401) {
            this.showDanger('Invalid credentials, please try again!');
          } else if (error.status === 403) {
            this.showDanger('Your account is not activated yet, please contact your administrator!');
          }
          else if (error.status === 404) {
            this.showDanger('Your account is not found, please contact your administrator!');
          }
          else if (error.status === 500) {
            this.showDanger('We are experiencing some issues, Please try after sometime!');
          }
        }
      );
  }

  logout(): void {
    this._auth.isLoggedIn = false;
  }

  showSuccess(successMessage) {
    //this.tagsInput.nativeElement.focus();
    this.toastService.show(successMessage, { classname: 'bg-success text-light', delay: 10000, autohide: true });
  }

  showDanger(dangerTpl) {
      this.toastService.show(dangerTpl, { classname: 'bg-danger text-light', delay: 15000, autohide: true });
  }

}
